import * as URLConfig from "../domain";

const config = URLConfig.config;

const faqsAndResourceConfig = {
  getFaqs: config.jmw + config.jmw_content + "faq/faqtab",
  getFaqsById: config.jmw + config.jmw_content + "faq/getqa/",
  getFaqsBySeacrh: config.jmw + config.jmw_content + "faq/searchfaq/",
  resource: config.jmw + config.jmw_content + "generalresource/",
};

export default faqsAndResourceConfig;
